import boletin from '../../../assets/media/logos/bgdl/bgdl-isotipo-color.svg'
import enlace from '../../../assets/media/logos/enlace/ej-isotipo-color.svg'
import buro from '../../../assets/media/logos/buro/buro-isotipo-color.svg'

////// FORM::Sistema del paquete //////
export default function Step1({
    formik,
    catalogo,
    setSistema,
}) {

    ////// Datos de los sistemas disponibles //////
    function sistemaLogo(s){
        switch (s){
            case "EJ":
                return {
                    logo: enlace,
                    descripcion : 'Acceso a cualquier estado.'
                };
            case 'BGDL':
                return {
                    logo: boletin,
                    descripcion : 'Acceso exclusivo a Jalisco.'
                };
            default:
                return {
                    logo: buro,
                    descripcion : 'Acceso exclusivo a '
                };
        }
    }

    ////// Asignar el valor del sistema elegido //////
    function handleChange(valor){
        formik.setFieldValue('sistema', valor);
        setSistema(valor);
        /////////// Reiniciar valores ///////////
        formik.setFieldValue('id_paquete', "");
        formik.setFieldValue('costo', "");
        formik.setFieldValue('contratacion', "Mensual");
        formik.setFieldValue('telefonos', [
            {
                telefono : ""
            }
        ]);
        formik.setFieldValue('correos', [
            {
                correo : "",
            }
        ]);
    }

    return (
        <div className="w-100">
            <div className="pb-8 pb-lg-10">
                <h2 className="fw-bold d-flex align-items-center text-gray-900" tabIndex={-1}>Crear un Nuevo Contrato</h2>
                <div className="text-muted fw-semibold fs-6">Seleccione la aplicaci&oacute;n
                    a contratar.
                </div>
            </div>
            <div className="fv-row">
                <div className="row">
                    {
                        catalogo.sistemas && catalogo.sistemas.map((s) => {
                            return(
                                <div key={s.valor} className="col-lg-6">
                                    <input type="radio" className="btn-check" name="sistema" value={s.valor} id={s.valor} onChange={() => handleChange(s.valor)} checked={s.valor === formik.values.sistema}/>
                                    <label className="btn btn-outline btn-outline-dashed btn-active-light-primary p-7 d-flex align-items-center mb-10" htmlFor={s.valor}>
                                        <img src={sistemaLogo(s.valor).logo} className="me-5 h-40px" alt={s.descripcion}/>
                                        <span className="d-block fw-semibold text-start">
                                            <span className="text-gray-900 fw-bold d-block fs-4 mb-1">{s.descripcion}</span>
                                            <span className="text-muted fw-semibold fs-6">{sistemaLogo(s.valor).descripcion}</span>
                                        </span>
                                    </label>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

